module.exports = __webpack_public_path__ + "img/trum-pool.e111e0d9.jpg";